/* @flow */

import React from 'react'

import type { User, LoginCredentials } from '../../types'

import logo from './login-icon_orange.svg'

export type Props = {
  credentials: LoginCredentials,
  loginButtonClick: (credentials: LoginCredentials) => void,
  setCredentials: (credentials: LoginCredentials) => void,
  isLoggingIn: boolean,
  currentUser: User,
  goToOldLibrary: () => void,
  goToLibrary: () => void,
}

export default function LoginForm(props: Props) {
  const onSubmit = e => {
    e.preventDefault()
    props.loginButtonClick(props.credentials)
  }
  const makeChangeHandler = key => {
    return e => {
      props.setCredentials(
        Object.assign({}, props.credentials, {
          [key]: e.target.value,
        })
      )
    }
  }

  return (
    <form
      className="form-login mt3 center f6 relative text-right align-self-center"
      onSubmit={onSubmit}
    >
      <img
        className="w-50 block center mb2"
        src={logo}
        alt="Log in logo"
        style={{ opacity: '.5' }}
      />
      <div className="flex flex-column mb3 cf">
        <input
          className="work-sans color-blue b--none pa3 bb b--gold f6 outline-0 mb3 login-input"
          placeholder="Username or Email"
          id="email"
          type="text"
          value={props.credentials.name}
          onChange={makeChangeHandler('name')}
        />
        <input
          className="work-sans color-blue b--none pa3 bb b--gold f6 outline-0 login-input"
          placeholder="Password"
          id="password"
          type="password"
          value={props.credentials.password}
          onChange={makeChangeHandler('password')}
        />
      </div>

      <button
        id="submit"
        className="work-sans white bg-op-brand b pt3 pb3 br2 login-button"
        disabled={props.isLoggingIn}
      >
        Log In
      </button>
    </form>
  )
}



// WEBPACK FOOTER //
// ./src/components/LoginForm/index.js